import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AuthService, UIService } from 'src/app/_services';

/** Read-only user page; the user comes from the list row (there is no get-user-by-id endpoint) */
@Component({
    selector: 'app-user-view',
    templateUrl: './user-view.component.html',
    styleUrls: ['../partners/view/partner-view.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class UserViewComponent implements OnInit {
  user: any;
  details: [string, string][] = [];

  constructor(private UIService: UIService, public auth: AuthService) { }

  ngOnInit() {
    this.UIService.setTitle('View User');
    this.user = history.state?.data?.user;
    if (!this.user) { return; }

    this.details = ([
      ['User UUID', this.user.id],
      ['Email', this.user.email],
      ['Phone', this.user.phone],
      ['Role', this.user.role],
      ['Partner', this.auth.hasAccess('SuperAdmin') && this.user.partner?.name],
    ] as [string, string][]).filter(([, value]) => value);
  }
}
